import { Amplify } from 'aws-amplify';

function readCognitoEnv() {
  const userPoolId = process.env.REACT_APP_COGNITO_USER_POOL_ID;
  const userPoolClientId = process.env.REACT_APP_COGNITO_CLIENT_ID;
  const rawDomain = process.env.REACT_APP_COGNITO_DOMAIN || '';
  const domain = rawDomain.replace(/^https?:\/\//i, '').split('/')[0];
  const redirectSignIn = process.env.REACT_APP_OAUTH_REDIRECT_SIGN_IN;
  const redirectSignOut = process.env.REACT_APP_OAUTH_REDIRECT_SIGN_OUT;
  return { userPoolId, userPoolClientId, domain, redirectSignIn, redirectSignOut };
}

/** Amplify に OAuth 設定が渡せるか（UI で未設定メッセージ用） */
export function isCognitoOAuthConfigured(): boolean {
  const { userPoolId, userPoolClientId, domain, redirectSignIn, redirectSignOut } = readCognitoEnv();
  return Boolean(userPoolId && userPoolClientId && domain && redirectSignIn && redirectSignOut);
}

/** ユーザープール＋クライアント ID があればメール＋パスワードで Amplify を初期化可能 */
export function isCognitoPasswordSignInConfigured(): boolean {
  const { userPoolId, userPoolClientId } = readCognitoEnv();
  return Boolean(userPoolId && userPoolClientId);
}

/** Cognito（メール＋パスワード・OAuth）。OAuth 用のドメイン／リダイレクトが揃うときだけ Hosted UI を有効化する。 */
export function configureAmplify(): void {
  const { userPoolId, userPoolClientId, domain, redirectSignIn, redirectSignOut } = readCognitoEnv();

  if (!userPoolId || !userPoolClientId) {
    return;
  }

  const oauthConfigured = Boolean(domain && redirectSignIn && redirectSignOut);

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId,
        loginWith: {
          email: true,
          ...(oauthConfigured
            ? {
                oauth: {
                  domain,
                  scopes: ['openid', 'email', 'profile'],
                  redirectSignIn: [redirectSignIn!],
                  redirectSignOut: [redirectSignOut!],
                  responseType: 'code' as const,
                },
              }
            : {}),
        },
      },
    },
  });
}
